import dashboardApi from '../../services/dashboardApi'

const state = {
	dashboard: null
}

const mutations = {

}

const actions = {
	async fetchDashboardDesa({ getters }, data) {
		let token = getters.getAuthService.token
		return await dashboardApi.fetchDashboardDesa(token, data)
	},
	async fetchDashboardKecamatan({ getters }, data) {
		let token = getters.getAuthService.token
		return await dashboardApi.fetchDashboardKecamatan(token, data)
	},
	async fetchDashboardDukcapil({ getters }, data) {
		let token = getters.getAuthService.token
		return await dashboardApi.fetchDashboardDukcapil(token, data)
	}
}

const getters = {
	getDashboard: state => {
		return state.dashboard
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}